import { LngModel } from '../models/lng';

import BaseApiService from './base-api-service';

export default class LngService extends BaseApiService {
  public async getLng(): Promise<LngModel> {
    const response = await this.getResource('/GetLNG');
    return response;
  }
}
